import * as THREE from 'three';

export interface SceneConfig {
  // Performance settings
  maxObjects: number;
  lodDistances: number[];
  shadowQuality: 'low' | 'medium' | 'high';
  
  // Visual settings
  fogDensity: number;
  ambientIntensity: number;
  bloomStrength: number;
  
  // Debug options
  showStats: boolean;
  wireframe: boolean;
  showHelpers: boolean;
}

export interface CameraTransform {
  position: THREE.Vector3;
  target: THREE.Vector3;
  fov?: number;
}

export interface LODLevel {
  distance: number;
  geometry: THREE.BufferGeometry;
}

export interface RenderStage {
  id: string;
  render: (renderer: THREE.WebGLRenderer, scene: THREE.Scene, camera: THREE.Camera) => void;
  enabled: boolean;
}

export interface PostProcessingConfig {
  bloom: {
    enabled: boolean;
    strength: number;
    radius: number;
    threshold: number;
  };
  
  depthOfField: {
    enabled: boolean;
    focusDistance: number;
    aperture: number;
    maxBlur: number;
  };
  
  motionBlur: {
    enabled: boolean;
    samples: number;
    intensity: number;
  };
}

export const DEFAULT_SCENE_CONFIG: SceneConfig = {
  maxObjects: 10000,
  lodDistances: [50, 200, 500],
  shadowQuality: 'medium',
  fogDensity: 0.001,
  ambientIntensity: 0.3,
  bloomStrength: 1.5,
  showStats: false,
  wireframe: false,
  showHelpers: false,
};

export const DEFAULT_POST_PROCESSING: PostProcessingConfig = {
  bloom: {
    enabled: true,
    strength: 1.5,
    radius: 0.4,
    threshold: 0.85,
  },
  depthOfField: {
    enabled: false,
    focusDistance: 100,
    aperture: 0.025,
    maxBlur: 0.01,
  },
  motionBlur: {
    enabled: false,
    samples: 32,
    intensity: 1.0,
  },
};